import { IMAGE } from '../elements/assets'
import { LINK_FIELD } from '../elements/link'

export const DEMO_CARD_CAROUSEL = `
...on demoCardCarousel_Entry {
  id
  typeHandle
  headingAdvanced { html }
  demoCards {
    ...on demoCard_Entry {
      id
      title
      demoCategory
      demoDuration
      ${IMAGE}
      ${LINK_FIELD}
    }
  }
}
`
